import { PaginationResponse } from "models/pagination-response";
import { IEstoqueMedicamentoPagedRequest } from "models/request/estoque-medicamento-paged-request";
import { IEstoqueMedicamentoPagedResponse } from "models/response/estoque-medicamento-paged-response";

export type EstoquesMedicamentoState = {
    estoques: PaginationResponse<IEstoqueMedicamentoPagedResponse>;
    estoquePagedRequest: IEstoqueMedicamentoPagedRequest;
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setEstoques = 'setEstoques',
    setEstoquePagedRequest = 'setEstoquePagedRequest',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const EstoquesMedicamentoReducer = (state: EstoquesMedicamentoState, action: any): EstoquesMedicamentoState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setEstoquePagedRequest:
            return { ...state, estoquePagedRequest: payload };
        case ACTION_TYPES.setEstoques:
            return { ...state, estoques: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
